import React from 'react';
import { Autocomplete, Box, TextField, styled } from '@mui/material';
import { useSearchParam } from 'helpers/useSearchParam';
import { useJobsContext } from 'components/JobList';

const FilterField = styled(Box)({
  minWidth: 160,
  flex: '1 1 160px',
  maxWidth: 240
});

export default function SelectDay() {
  const { onDaySelectChange } = useJobsContext();
  const [day] = useSearchParam('day');

  const options = [
    { value: '*', label: 'Everyday' },
    { value: '0', label: 'Sunday' },
    { value: '1', label: 'Monday' },
    { value: '2', label: 'Tuesday' },
    { value: '3', label: 'Wednesday' },
    { value: '4', label: 'Thursday' },
    { value: '5', label: 'Friday' },
    { value: '6', label: 'Saturday' }
  ];

  const selected = options.find((option) => option.value === day) || null;

  return (
    <FilterField>
      <Autocomplete
        clearOnEscape
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, selectedValue) =>
          option.value === selectedValue.value
        }
        onChange={(_event, next) => onDaySelectChange(next?.value || '')}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Day"
            placeholder="Search day"
            size="small"
          />
        )}
        size="small"
        value={selected}
      />
    </FilterField>
  );
}
